import LazyMotionWrapper from 'components/lazy-motion-wrapper';
import { AddressesContextProvider } from 'contexts/addresses';
import { useCart } from 'contexts/cart';
import SubscriptionFunnel from 'modules/subscription-funnel';
import { SubscriptionFunnelProvider } from 'modules/subscription-funnel/state';
import { NextPage } from 'next';
import React, { useEffect, useRef } from 'react';

const Futterabo: NextPage = () => {
  const { resetCheckout } = useCart();
  /**
   * Reset cart when user lands on abo funnel.
   * As some of the feature functions on the premise that the cart is empty
   */
  const init = useRef(false);
  useEffect(() => {
    if (!init.current) {
      resetCheckout();
      init.current = true;
    }
  }, [resetCheckout]);
  return (
    <AddressesContextProvider>
      <SubscriptionFunnelProvider>
        <LazyMotionWrapper>
          <SubscriptionFunnel />
        </LazyMotionWrapper>
      </SubscriptionFunnelProvider>
    </AddressesContextProvider>
  );
};

export default Futterabo;
